export default function Card({ children, className = '', interactive = false, ...props }) {
  const baseStyles = 'bg-surface border border-border rounded-xl p-4'
  const interactiveStyles = interactive ? 'hover:bg-surface-bright hover:border-accent cursor-pointer transition-all' : ''

  return (
    <div className={`${baseStyles} ${interactiveStyles} ${className}`} {...props}>
      {children}
    </div>
  )
}
